import React from 'react';
import { useChatStore } from '../../stores/useChatStore';
import './ModelSelector.css';

export default function ModelSelector() {
  const { models, sessions, currentSessionId, renameSession } = useChatStore();
  const session = sessions.find((s) => s._id === currentSessionId);
  if (!session) return null;

  // We don't allow changing model mid-session (would break cost tracking).
  // Show as read-only label with pricing details.
  const m = models.find((mm) => mm.key === session.model);
  if (!m) return <span className="model-tag">Modell: {session.model}</span>;

  return (
    <div className="model-tag" title={`Input: $${m.inputPerM}/M · Output: $${m.outputPerM}/M`}>
      <span className="model-tag-label">{m.label}</span>
      <span className="model-tag-price">
        ${m.inputPerM.toFixed(2)}↑ / ${m.outputPerM.toFixed(2)}↓ pro 1M
      </span>
    </div>
  );
}
